"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
var _allCouponList = _interopRequireDefault(require("@/components/allCouponList"));
var _index = _interopRequireDefault(require("@/views/member/shoppingCredit/settings/index"));
var $constants = _interopRequireWildcard(require("@/utils/constants"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var tableFroms = {
  page: 1,
  limit: $constants.page.limit[0],
  identityType: 1,
  status: 1
};
var _default = exports.default = {
  name: 'c_coupon_select',
  props: {
    configObj: {
      type: Object
    },
    configNme: {
      type: String
    }
  },
  components: {
    draggable: _vuedraggable.default,
    allCouponList: _allCouponList.default,
    shoppingCredit: _index.default
  },
  data: function data() {
    return {
      tableFrom: Object.assign({}, tableFroms),
      defaults: {},
      configData: {},
      dialogVisible: false,
      keyNum: 0,
      list: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      _this.defaults = _this.configObj;
      _this.configData = _this.configObj[_this.configNme];
      _this.getChecked();
    });
  },
  watch: {
    configObj: {
      handler: function handler(nVal, oVal) {
        this.defaults = nVal;
        this.configData = nVal[this.configNme];
        this.getChecked();
      },
      deep: true
    }
  },
  methods: {
    getChecked: function getChecked() {
      if (!this.configData.list.length) {
        this.list = [];
      } else {
        this.list = this.configData.list;
      }
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    handleConfirm: function handleConfirm() {
      this.configData.list = this.list;
      this.configData.ids = this.configData.list.map(function (item) {
        return item.id;
      }).join(',');
      this.$emit('getConfig', this.list);
      this.dialogVisible = false;
    },
    handleAdd: function handleAdd() {
      this.keyNum += 1;
      this.dialogVisible = true;
    },
    changeSelection: function changeSelection(selection) {
      this.list = selection;
    },
    getCouponId: function getCouponId(data) {
      // data 是选中的优惠券列表
      // 我们需要将选中的优惠券添加到 configData.list 中
      // 这里可能需要去重，或者直接覆盖，取决于需求。通常是追加或替换。
      // 假设是替换选中的集合 (CouponList logic usually returns all selected)
      // 但 CouponList 的 getCouponId 返回的是 multipleSelectionAll

      // 简单处理：将返回的数据映射为我们需要的数据格式
      // 注意：configData.list 中的数据结构应该包含 id, money, minPrice 等
      // 假设 CouponList 返回的对象已经包含了这些字段
      this.configData.list = data.map(function (item) {
        return _objectSpread({
          id: item.id,
          money: item.money,
          minPrice: item.minPrice,
          name: item.name
        }, item);
      });
      this.dialogVisible = false;
    },
    deleteCoupon: function deleteCoupon(index) {
      this.configData.list.splice(index, 1);
      this.configData.ids = this.configData.list.map(function (item) {
        return item.id;
      }).join(',');
    }
  }
};